import React from 'react';
import './info-img.css';

interface InfoBlock {
  title: string;
  content: string;
}

interface Props {
  className?: string;
  src: string;
  alt: string;
  blocks: Array<InfoBlock>;
}

class InfoImg extends React.Component<Props> {
  
  infoBlockView(block: InfoBlock, index: number): JSX.Element {
    return (
      <div key = {`${block.title}-${index}`} className="info-img-block">
        <p className="text-2 bold">{ block.title }</p>
        <p>{ block.content }</p>
      </div>
    );
  }
  
  render(): JSX.Element {
    const { src, alt, blocks } = this.props;
    
    return (
      <div className="info-img">
        <img src={ src } alt={ alt }></img>
        <div className="info-img-blocks">
          { blocks.map( this.infoBlockView) }
        </div>
      </div>
    );
  }
}

export default InfoImg;